import React from 'react';

import { ReliasTraining } from '@uplift/api';

import { RequiredTrainingsCard } from '../../../onboarding-dashboard/components/todo-items/RequiredTrainings/RequiredTrainingsCard';

export type RequiredTrainingsToDoProps = {
  trainings: ReliasTraining[];
  lastSyncedAt: string | null;
};

// Same "Complete required trainings" design as the onboarding "Getting Started" modal
// (RequiredTrainingsCard is shared), surfaced here too since HIPAA & Security is an annual
// training — it can go from completed back to a to-do long after onboarding has ended, once
// the onboarding modal has permanently stopped rendering for the provider. Whether to show this
// at all (including hiding when there's nothing synced yet) is decided by the caller
// (to-dos.main.tsx), since that also drives the "N Item(s) To Do" count.
export const RequiredTrainingsToDo: React.VFC<RequiredTrainingsToDoProps> = ({ trainings, lastSyncedAt }) => (
  <RequiredTrainingsCard trainings={trainings} lastSyncedAt={lastSyncedAt} />
);
